import React, { useEffect } from "react";

// Before the Account row (#llm-login), the app kept the Claude OAuth token in localStorage; the
// reducer read these three keys at boot (origin/production src/reducer.tsx:296-298) and wrote them
// on SET_CLAUDE_OAUTH_TOKEN (552-556). The readers and writers are gone, so a browser that used
// the old build still has a secret sitting in localStorage. Delete it once, at boot.
export const LEGACY_CLAUDE_AUTH_KEYS = [
  "claude_oauth_token",
  "claude_refresh_token",
  "claude_expires",
] as const;

export const clearLegacyClaudeAuth = (storage: Storage = localStorage): void => {
  for (const key of LEGACY_CLAUDE_AUTH_KEYS) storage.removeItem(key);
};

// Rendered by App. useEffect runs after the first paint; removeItem is idempotent and safe when
// the keys were never there.
export const LegacyClaudeAuthCleanup: React.FC = () => {
  useEffect(() => {
    clearLegacyClaudeAuth();
  }, []);
  return null;
};
